// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__vp0Z5","heading__title":"Heading_heading__title__mKNIR","heading__desc":"Heading_heading__desc__mBSyr"};